export enum EntitiesPerPageEnum {
  TWENTY_FIVE = 25,
  FIFTY = 50,
  HUNDRED = 100,
}
